module.exports = __webpack_public_path__ + "static/media/currentdate.0231d8b8.svg";